// Le renouvellement que la porte (`sessionGuardedFetch.ts`) appelle quand elle
// retient une requête.
//
// Il vit dans un fichier à part parce qu'il a besoin du client Supabase, alors
// que la porte est construite DANS `client.ts`. `AuthContext` fait la jonction
// en appelant `registerSessionRefresher(refreshSessionForGuard)` au démarrage.
//
// On délègue à `recoverFromAuthError` plutôt que d'appeler `refreshSession()`
// en direct : ce module porte déjà les trois verrous mesurés le 5 août 2026
// (un seul renouvellement en vol, un seul message par rafale, arrêt définitif
// après échec). Les réécrire ici créerait deux sources de vérité qui
// divergeraient.

import { supabase } from '@/integrations/supabase/client';
import { recoverFromAuthError } from '@/lib/authErrorRecovery';

/** Le nouveau JWT, ou `null` si la session est perdue. Ne lève jamais. */
export async function refreshSessionForGuard(): Promise<string | null> {
  try {
    // `{ status: 401 }` est la forme que `isAuthSessionError` reconnaît.
    const outcome = await recoverFromAuthError({ status: 401 });
    if (outcome !== 'recovered') return null;

    const { data } = await supabase.auth.getSession();
    return data?.session?.access_token ?? null;
  } catch {
    // Appelée depuis la porte : une exception ici ferait échouer la requête
    // d'une manière que rien en aval ne sait interpréter.
    return null;
  }
}
